import { useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';

const Decline = () => {
  const router = useRouter();
  const { t: translatedTextPhoneVerification } = useTranslation('myVaro', {
    keyPrefix: 'phoneVerification',
  });
  const goBack = () => {
    router.dismissTo({ pathname: '/myvaro/personal-details' });
  };
  useBackHandler(goBack);
  return (
    <View style={styles.container}>
      <ScreenTransitionOverlay
        isLoading={false}
        LoadingComponent={undefined}
        ErrorComponent={
          <ErrorScreen
            screenType={ErrorScreenType.Warning}
            messageHeadline={translatedTextPhoneVerification('error.header')}
            messageBody={translatedTextPhoneVerification('error.description')}
            primaryButton={{
              title: translatedTextPhoneVerification('error.primaryButton'),
              onPress: () => {
                router.push({
                  pathname: '/myvaro/help',
                });
              },
            }}
            secondaryButton={{
              title: translatedTextPhoneVerification('error.secondaryButton'),
              onPress: () => {
                goBack();
              },
            }}
          />
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default Decline;
